import styles from './new-tag.module.scss';
import texts from './new-tag.texts.json';

export const NewTag = () => {
  return <span className={styles.tag}>{texts.new}</span>;
};
